import { clsx } from 'clsx';
import type { ReactNode } from 'react';

export function EstadoVazio({ icone, titulo, texto, acao }: { icone?: ReactNode; titulo: string; texto?: string; acao?: ReactNode }) {
  return (
    <div className="estado-vazio" role="status">
      {icone}
      <p className="tp-secao" style={{ color: 'var(--texto)', margin: 0 }}>{titulo}</p>
      {texto && <p style={{ margin: 0 }}>{texto}</p>}
      {acao}
    </div>
  );
}

export function Esqueleto({ linhas = 3, forma = 'linha', className }: { linhas?: number; forma?: 'linha' | 'cartao' | 'campo'; className?: string }) {
  const altura = forma === 'cartao' ? 72 : forma === 'campo' ? 40 : 12;
  return (
    <div className={clsx('esqueletos', className)} aria-hidden="true" style={{ display: 'grid', gap: 10 }}>
      {Array.from({ length: linhas }, (_, i) => (
        <div key={i} className="esqueleto" style={{ height: altura, width: forma === 'linha' ? `${92 - ((i * 17) % 40)}%` : '100%' }} />
      ))}
    </div>
  );
}

/** Faixa de mensagem; erro de servidor mostra a mensagem e o código copiável (07 §10). */
export function Faixa({ tipo, children, codigo, acao }: { tipo: 'erro' | 'aviso' | 'info'; children: ReactNode; codigo?: string; acao?: ReactNode }) {
  return (
    <div className="faixa" data-tipo={tipo} role={tipo === 'erro' ? 'alert' : 'status'}>
      <span>{children}</span>
      {acao}
      {codigo && <span className="codigo-erro">{codigo}</span>}
    </div>
  );
}
